<vn-header-bar
    [enabled]="media.isActive('lt-md')"
    [showClose]="config.account.showHeaderBarClose"
    [title]="item.text"
    [showBack]="false"
    (onClose)="close()" />
@for (child of item.children; track trackByProp($index, child)) {
    <ng-container *vnDynamicComponent="getItemComponent(child.type); attr: { item: child }" />
}
